import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/transportadoras',
  component: mainComponent,
  title: 'Transportadoras',
  children: [{
    path: '/',
    name: 'carrier-list',
    component: () => import('@/views/carrier/CarrierList.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Transportadoras', active: true },
      ],
      pageTitle: 'Transportadoras',
      rule: 'editor',
    },
  }],
}, ];